import cn from 'classnames';
import * as React from 'react';

import BaseClickable from 'components/ui/BaseClickable';

import s from './SettingsItem.module.scss';

type Props = {
  active?: boolean;
  onClick: VoidFunction;
  className?: string;
  content: React.ReactNode;
};

const SettingsItem: React.FC<Props> = ({ active = false, onClick, content, className }) => {
  return (
    <BaseClickable className={cn(s.root, active && s['root_active'], className)} type="button" onClick={onClick}>
      {content}
    </BaseClickable>
  );
};

export default SettingsItem;
